import { initializeApp } from 'firebase/app';

// Configuración de la consola de Firebase
const firebaseConfig = (['buzon.ease.gob.mx', 'buzon.ased.gob.mx'].includes(window.location.hostname))
    ? {
        apiKey: 'AIzaSyCI7Um-tumCtw4jWGGpf2J01d4dDV-33NM',
        authDomain: 'buzon-prod.firebaseapp.com',
        projectId: 'buzon-prod',
        storageBucket: 'buzon-prod.firebasestorage.app',
        messagingSenderId: '154437094578',
        appId: '1:154437094578:web:325d3f75720b09cd6dcdab',
        measurementId: 'G-PQTWGZS1DL',
    }
    : {
        apiKey: 'AIzaSyBF10y2iDovCWUTAJF13HuhqhA40QqewxA',
        authDomain: 'buzon-dev.firebaseapp.com',
        projectId: 'buzon-dev',
        storageBucket: 'buzon-dev.firebasestorage.app',
        messagingSenderId: '757852304394',
        appId: '1:757852304394:web:be24a3fb7dedb17f661bf3',
        measurementId: 'G-F60NEPMXRR',
    };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
